import React from 'react';

import PropTypes from 'prop-types';

import { i18nMoney } from 'wanderu-i18n';

import {
    HORIZONTAL_OFFSET,
    VERTICAL_OFFSET,
} from '../constants';

import styles from './VerticalAxis.scss';

const propTypes = {
    height: PropTypes.number.isRequired,
    scalingFactor: PropTypes.number.isRequired,
    type: PropTypes.oneOf(['number', 'price']),
    values: PropTypes.arrayOf(PropTypes.number).isRequired,
    width: PropTypes.number.isRequired,
};
const defaultProps = {
    type: 'price',
};

function VerticalAxis(props) {
    const {
        height,
        scalingFactor,
        type,
        values,
        width,
    } = props;

    return (
        <svg>
            {values.map((value) => {
                const scaledValue = value * scalingFactor;
                const lineYPosition = height - scaledValue + VERTICAL_OFFSET;
                const textYPosition = height - scaledValue + VERTICAL_OFFSET * 1.5;

                return (
                    <g
                        className={styles.axisLine}
                        key={value}
                    >
                        {!!value && (
                            <text
                                className={styles.label}
                                x={0}
                                y={textYPosition}
                            >
                                {type === 'price'
                                    ? i18nMoney(value).format({
                                        maximumFractionDigits: 0,
                                        minimumFractionDigits: 0,
                                    })
                                    : value}
                            </text>
                        )}
                        <line
                            className={styles.line}
                            x1={HORIZONTAL_OFFSET}
                            x2={width}
                            y1={lineYPosition}
                            y2={lineYPosition}
                        />
                    </g>
                );
            })}
        </svg>
    );
}

VerticalAxis.propTypes = propTypes;
VerticalAxis.defaultProps = defaultProps;

export default VerticalAxis;
